import React from "react";

import { PersonBlock as Value } from "@reactivated";

import { ImageChooserBlock } from "@thelabnyc/thelabui/src/components/ImageChooserBlock";

import { delegateClickToLink } from "../../utils/delegateClickToLink";
import { RichTextStreamBlock } from "../RichTextStreamBlock";

import styles from "./PersonBlock.module.scss";

interface Props {
    value: Value;
}

export const PersonBlock = ({ value }: Props) => {
    if (!value.image) return null;

    return (
        <figure className={styles.item} onClick={delegateClickToLink}>
            <ImageChooserBlock
                attrs={{ className: styles.imageContainer }}
                value={value.image}
                imageAttrs={{ className: styles.image, alt: "" }}
                sizes={styles.sizes}
            />
            <figcaption className={styles.caption}>
                <RichTextStreamBlock value={value.content ?? null} />
            </figcaption>
        </figure>
    );
};
